import { Col, Row } from 'react-bootstrap';
import { getPaymentMethodText } from '../../../../utils/getPaymentMethodText';
import { formatCurrency } from '../../../../utils/strings';
import { StyledData, StyledDataHeader, StyledSectionTitle } from '../styles';
import getFreightValue from '../../../../utils/getFreightValue';
import useInvoiceFreight from '../../../../hooks/useInvoiceFreight';

interface PaymentData {
    invoiceId: string;
    method: string;
    total: string;
    commission: number;
    discountPercentage: string;
    interestPercentage: string;
    freightPercentage: number;
    addressType: string;
}

interface Props {
    paymentData: PaymentData;
}

export default function InvoicePaymentData({ paymentData }: Props) {
    const subtotal = Number(paymentData.total);
    const {
        commission,
        discountPercentage,
        interestPercentage,
        freightPercentage,
        invoiceId,
        addressType,
    } = paymentData;

    const discount = subtotal * (Number(discountPercentage) / 100);

    const interest =
        (subtotal + commission - discount) * (Number(interestPercentage) / 100);

    const netInvoiceValue = subtotal + commission + interest - discount;

    const { data: invoiceFreightPercentage = 0 } = useInvoiceFreight(
        invoiceId,
        freightPercentage,
    );

    const willPickup = addressType === 'pickup';

    const freightValue = willPickup
        ? 0
        : getFreightValue(netInvoiceValue, invoiceFreightPercentage);

    const total = netInvoiceValue + freightValue;

    return (
        <>
            <StyledSectionTitle>Pagamento</StyledSectionTitle>

            <Row>
                <Col>
                    <StyledDataHeader>Método de pagamento</StyledDataHeader>
                    <StyledData>
                        {getPaymentMethodText(paymentData.method) || '-'}
                    </StyledData>
                </Col>
                <Col>
                    <StyledDataHeader>Total</StyledDataHeader>
                    <StyledData>{formatCurrency(total)}</StyledData>
                </Col>
            </Row>

            <Row>
                <Col>
                    <StyledDataHeader>Subtotal</StyledDataHeader>
                    <StyledData>{formatCurrency(subtotal)}</StyledData>
                </Col>
                <Col>
                    <StyledDataHeader>Comissão</StyledDataHeader>
                    <StyledData>{formatCurrency(commission)}</StyledData>
                </Col>
            </Row>

            <Row>
                <Col>
                    <StyledDataHeader>Acréscimos</StyledDataHeader>
                    <StyledData>{formatCurrency(interest)}</StyledData>
                </Col>
                <Col>
                    <StyledDataHeader>Desconto</StyledDataHeader>
                    <StyledData>{formatCurrency(discount)}</StyledData>
                </Col>
            </Row>
            <Row>
                <Col>
                    <StyledDataHeader>Frete</StyledDataHeader>
                    <StyledData>{formatCurrency(freightValue)}</StyledData>
                </Col>
            </Row>
        </>
    );
}
